<template>
  <div class="mision">
    <router-link
      to="/progreso"
      class="miperfil abs pointer"
      data-aos="fade-right"
      data-aos-delay="200"
    >
      <img
        src="../../../assets/imgs/mision/btn-mi-perfil.png"
        alt="Encauce"
        class="img-fluid w-100"
      />
    </router-link>

    <section
      class="pantalla mision1_1"
      v-bind:class="{
        bg1: reto == 0,
        bg2: reto == 1,
        bg3: reto == 2,
        bg4: reto == 3,
        bg5: reto == 4,
        bg6: reto == 5,
        bg7: reto == 6,
        bg8: reto == 7,
        bg9: reto == 8,
      }"
      v-if="!resultado && reto != -1"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div class="pregunta abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/mision/bg-pregunta-trapezoide.png"
                alt="Encauce"
                class="img-fluid w-100"
              />
              <div
                class="pregunta_txt abs"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div class="blanco bold" v-html="retos[reto].texto"></div>
                <div class="electrico" v-html="retos[reto].instruccion"></div>
              </div>
            </div>

            <div class="quasar abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/mision/quasar-verde.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div
              @click="avanzar"
              class="btnavanzar abs"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <img
                src="../../../assets/imgs/mision/bg-flecha-siguiente.png"
                alt="Encauce"
                class="img-fluid"
              />
              <div class="texto electrico d-flex flex-column">
                <span>Presiona la flecha </span>
                <span class="bold">para continuar</span>
              </div>
            </div>

            <div
              @click="retroceder"
              class="btnretroceder abs"
              data-aos="fade-left"
              data-aos-delay="200"
              v-if="this.reto > 0"
            >
              <img
                src="../../../assets/imgs/mision/bg-flecha-atras.png"
                alt="Encauce"
                class="img-fluid"
              />
              <div class="texto electrico d-flex flex-column">
                <span>Regresar al </span>
                <span class="bold">reto anterior</span>
              </div>
            </div>

            <div
              @click="toggleOraculo"
              class="oraculo abs"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <img
                src="../../../assets/imgs/mision/oraculo.png"
                alt="Encauce"
                class="img-fluid w100 btnoraculo"
              />
              <div
                class="dialogo"
                :class="{ active: oraculo === true && tip_oraculo != null }"
              >
                <img
                  src="../../../assets/imgs/mision/dialogo-oraculo.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="cerrar blanco bold">x</div>
                <div class="titulo cyan bold uppercase">
                  {{ tip_oraculo.tipo }}
                </div>
                <div class="texto blanco text-center">
                  {{ tip_oraculo.texto }}
                </div>
              </div>
            </div>

            <!---->

            <div class="menu">
              <img
                src="../../../assets/imgs/mision/medidor-afinidad.png"
                alt="Encauce"
                class="img-fluid medidor"
              />

              <div class="contenedoropciones">
                <sortable
                  class="opcionessortable"
                  v-for="(item, index) in retos[reto].respuestas"
                  v-model="dragData"
                  v-bind:key="item.id"
                  :index="index"
                  drag-direction="horizontal"
                  replace-direction="horizontal"
                  @sortend="sortend($event, retos[reto].respuestas, reto)"
                  @real-click="click"
                >
                  <div class="opcion">
                    <img
                      src="../../../assets/imgs/mision/bg-pregunta-grande.png"
                      alt="pregunta"
                    />
                    <div class="texto" v-html="item.texto"></div>
                  </div>
                </sortable>
              </div>

              <!-- <div
                class="tiempo-score d-flex blanco"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <span class="px3">TIEMPO:</span>
                <span>{{ time }} seg</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <section v-else>
      <div class="mision resultado">
        <div class="row">
          <div
            class="col-12 contentabs d-flex flex-column justify-content-center"
          >
            <div class="logo abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/encauce-logo-blanco-stem.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>
            <div class="tiempo abs text-center mtn7">
              <div class="cyan pt7 ls3" data-aos="fade-up" data-aos-delay="0">
                TIEMPO DE RESPUESTA:
              </div>

              <div
                class="cyan pt2 numero"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <img
                  class="medidor"
                  src="../../../assets/imgs/mision/medidor.png"
                  alt="respuesta"
                />
                <div class="ls3 electrico valor bold">{{ time }}</div>
                <div class="electrico bold ls6 unidad">SEGUNDOS</div>
              </div>

              <div
                class="cyan ls3 corchetes"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <span>
                  <img
                    class="izq"
                    src="../../../assets/imgs/mision/corchete-izq.png"
                    alt="respuesta"
                  />
                  <span class="bold">¡ooh! eres rápido</span>
                  <img
                    class="der"
                    src="../../../assets/imgs/mision/corchete-der.png"
                    alt="respuesta"
                  />
                </span>
              </div>

              <div class="py3"></div>

              <div
                class="cyan ls3 quasar-respuesta"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <img
                  src="../../../assets/imgs/mision/quasar-respuesta.png"
                  alt="respuesta"
                />
                <div class="texto">
                  <div class="text-left">
                    <span class="bold">¡Bien explorador!</span> Ahora veamos qué
                    harás cuando tienes que
                    <span class="bold">aprender algo nuevo.</span>
                    <img
                      src="../../../assets/imgs/mision/vineta-final.png"
                      alt="respuesta"
                    />
                  </div>
                </div>
              </div>

              <div
                class="col-12 footer"
                data-aos="fade-left"
                data-aos-delay="600"
              >
                <div class="row">
                  <div
                    class="col-4 offset-4 cyan d-flex justify-content-center flex-column"
                  >
                    <div>Misión 01- Planeta Aprentix 12</div>
                    <div class="bold">
                      <span class="diagonales">///</span> Reto 01 de 04
                      Completado
                    </div>
                  </div>
                  <div class="col-4 cont-btn-sig">
                    <button @click="siguienteMision" class="btn-sig">
                      <span class="texto">
                        <span class="bold">SIGUIENTE MISIÓN</span>
                      </span>
                      <img
                        class="icono"
                        src="../../../assets/imgs/mision/cohete.png"
                        alt="icono"
                      />
                      <span class="flecha">
                        <img
                          src="../../../assets/imgs/mision/flecha-sig3.png"
                          alt="icono"
                        />
                      </span>
                    </button>
                    <div class="flecha2">
                      <img
                        src="../../../assets/imgs/mision/flecha-sig2.png"
                        alt="icono"
                      />
                    </div>
                    <div class="flecha1">
                      <img
                        src="../../../assets/imgs/mision/flecha-sig1.png"
                        alt="icono"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="hidden abs">
      <img
        src="../../../assets/imgs/mision/1/bg-mision-1-1.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/1/bg-mision-1-2.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/1/bg-mision-1-3.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/1/bg-mision-1-4.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/1/bg-mision-1-5.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/1/bg-mision-1-6.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/1/bg-mision-1-7.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/1/bg-mision-1-8.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/1/bg-mision-1-9.jpg"
        alt="precarga"
      />
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import { mapState } from "vuex";
import swal from "sweetalert2";
import router from "../../../router/index";

import Sortable from "vue-drag-sortable";

export default {
  components: {
    Footer,
    Sortable,
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
      },
      tip_oraculo: null,
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      res: -1,
      oraculo: false,
      resultado: false,
      time: 0,
      mision: 1,
      reto: -1,
      dragData: {},
      lista_ordenada: null,
      habilidad: [
        "EXPERIENCIA CONCRETA",
        "OBSERVACIÓN REFLEXIVA",
        "CONCEPTUALIZACIÓN ABSTRACTA",
        "EXPERIMENTACIÓN ACTIVA",
      ],
      retos: [
        {
          id: 1,
          texto:
            "Se aproxima un asteroide a gran velocidad, ¿qué harías para evitar el choque?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Me enfoco en lo más importante",
              habilidad: 0,
            },
            {
              texto: "Hago prueba y error hasta encontrar la solución.",
              habilidad: 1,
            },
            {
              texto: "Me involucro a fondo, pongo todo mi esfuerzo y energía.",
              habilidad: 2,
            },
            {
              texto:
                "Busco solucionarlo con el menor esfuerzo y tiempo posible.",
              habilidad: 3,
            },
          ],
        },
        {
          id: 2,
          texto:
            "Estás en una zona desconocida del universo y tienes que averiguar cómo regresar a la ruta conocida, ¿qué haces?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto:
                "Me baso en los conocimientos y principios que ya conozco.",
              habilidad: 0,
            },
            {
              texto:
                "Examino los detalles y observo lo que sucede, no me imagino ni busco explicaciones.",
              habilidad: 1,
            },
            {
              texto: "Exploro los aspectos concretos y tangibles del problema.",
              habilidad: 2,
            },
            {
              texto: "Me involucro activamente, hago operaciones prácticas.",
              habilidad: 3,
            },
          ],
        },
        {
          id: 3,
          texto:
            "Lograste salir de la zona desconocida pero no sabes por qué sucedió una falla, tienes algo de tiempo para averiguarlo, ¿cómo lo harías?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto:
                "Considero lo que sucede en el presente antes que concentrarme sobre algo que sucedió antes o está por suceder.",
              habilidad: 0,
            },
            {
              texto:
                "Pienso, reflexiono, el problema da vueltas en mi cabeza, lo 'mastico mentalmente'.",
              habilidad: 1,
            },
            {
              texto:
                "Me preocupo sobretodo de las perspectivas del futuro, trato de prever y/o prevenir lo que podría eventualmente suceder con relación a ello.",
              habilidad: 2,
            },
            {
              texto:
                "Buscando efectos o usos prácticos. Antes de gastar energías, me preocupo primero de que va a servirme, qué aplicación práctica podría tener en la vida de todos los días.",
              habilidad: 3,
            },
          ],
        },
        {
          id: 4,
          texto:
            "Llegaste a un nuevo planeta. Ahora tienes que investigar cómo funciona la brújula interdimensional que te llevará a la base humana, ¿cómo conseguirás aprenderlo?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto:
                "Pongo atención en su funcionamiento y separo los mayores elementos posibles.",
              habilidad: 0,
            },
            {
              texto:
                "Me esfuerzo en comprender completamente su funcionamiento.",
              habilidad: 1,
            },
            {
              texto: "Analizo cómo funciona separándola por partes.",
              habilidad: 2,
            },
            {
              texto:
                "Soy lo más objetivo posible, la estudio sin pensar que es una brújula diferente.",
              habilidad: 3,
            },
          ],
        },
        {
          id: 5,
          texto:
            "Tienes que llegar a la base humana, pero hay que recorrer varios kilómetros y la nave no arranca. Tendrás que utilizar las botilácticas y no sabes cómo funcionan, ¿cómo lo resuelves?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto:
                "Soy fiel a mi intuición, es mi forma de ser en situaciones desconocidas.",
              habilidad: 0,
            },
            {
              texto:
                "Observo atentamente para entender cómo funciona su mecanismo.",
              habilidad: 1,
            },
            {
              texto:
                "Pienso en la dificultad que tiene su uso para darle solución.",
              habilidad: 2,
            },
            {
              texto:
                "Rápidamente tomo acción me las coloco para saber cómo fucionan.",
              habilidad: 3,
            },
          ],
        },
        {
          id: 6,
          texto:
            "Aprendiste a utilizar las botilácticas, pero en este planeta los polos cambian de posición cada 5 minutos y la nave ya se encuentra en otro lado, ¿cómo reaccionarías ante esta situación?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto:
                "Acepto la realidad tal cual es y parto de los hechos tal como son.",
              habilidad: 0,
            },
            {
              texto:
                "Me gustan las nuevas experiencias, no tomo los caminos tradicionales.",
              habilidad: 1,
            },
            {
              texto:
                "Evalúo y tomo en cuenta la situación antes de tomar una decisión.",
              habilidad: 2,
            },
            {
              texto:
                "Me enfoco en la claridad de las ideas, me mantengo abierto y perceptivo.",
              habilidad: 3,
            },
          ],
        },
        {
          id: 7,
          texto:
            "Te das cuenta que los habitantes del planeta siguen las indicaciones de las señales de tránsito al revés de como se indican, ¿qué haces tú?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Confío totalmente en mi intuición.",
              habilidad: 0,
            },
            {
              texto:
                "Me enfoco en entender concretamente la utilidad de hacerlo al revés.",
              habilidad: 1,
            },
            {
              texto: "Trato de aplicar un razonamiento lógico riguroso.",
              habilidad: 2,
            },
            {
              texto:
                "Me hago todo tipo de preguntas tratando de buscar respuestas satisfactorias.",
              habilidad: 3,
            },
          ],
        },
        {
          id: 8,
          texto:
            "Te informan que hubo un error en el sistema debido a la programación de la nave, ¿cómo vas a evitar que suceda de nuevo?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Aprendo de mi experiencia y la de los demás.",
              habilidad: 0,
            },
            {
              texto:
                "Manteniendo mi atención, analizando y observando todo lo que sucedió.",
              habilidad: 1,
            },
            {
              texto:
                "Elaborando una explicación teórica que muestre, los diversos aspectos del problema.",
              habilidad: 2,
            },
            {
              texto:
                "Experimento con la nave para estudiar los aspectos del problema.",
              habilidad: 3,
            },
          ],
        },
        {
          id: 9,
          texto:
            "Un agente espacial te avisará de una misión que ningún otro agente ha podido resolver, ¿qué haces?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto:
                "Pongo atención sobre la misión y reflexiono hasta llegar a una conclusión.",
              habilidad: 0,
            },
            {
              texto:
                "Soy prudente y moderado, me documento bien antes de afrontar la misión.",
              habilidad: 1,
            },
            {
              texto:
                "Utilizo mi razonamiento y juicio lógico para resolver la misión.",
              habilidad: 2,
            },
            {
              texto: "Reconozco todas las opciones posibles para resolverla.",
              habilidad: 3,
            },
          ],
        },
      ],
      respuestas_usuario: null,
      avance: null,
      x: null,
      y: null,
      resultado_evaluacion: null,
      valores: [4, 3, 2, 1],
      suma: { habilidad_0: 0, habilidad_1: 0, habilidad_2: 0, habilidad_3: 0 },
      initiated: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("cambio de ruta");

      this.initiated = false;

      this.init();
    },
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  mounted: function () {
    this.init();
  },
  methods: {
    init() {

      if (this.userProfile == null || this.initiated == true) {
        return;
      }

      console.log("iniciando mision " + this.mision);

      this.initiated = true;

      //////////////////////////
      this.reto = this.$route.params.reto - 1;

      this.setRespuestasUsuario();

      AOS.init({
        offset: -120, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 800, // values from 0 to 3000, with step 50ms
        easing: "ease-in-out", // default easing for AOS animations
        once: false, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
      });
      this.initTimer();
      this.getOraculo();
    },
    getOraculo() {
      let oraculo = this.$store.state.oraculo;
      let rand = Math.floor(Math.random() * (oraculo.length - 1)) + 0;
      this.tip_oraculo = oraculo[rand];
    },
    async setRespuestasUsuario() {
      console.log({ reto: this.reto });
      if (this.reto == 0) {
        this.respuestas_usuario = this.retos;
        await this.getAvance();
      } else {
        await this.getLocalStorage();
      }

      console.log({ respuestas_usuario: this.respuestas_usuario });
    },
    async getAvance() {
      console.log({ reto: this.reto - 1 });
      this.avance = await this.$store.dispatch("getAvance");
      this.respuestas_usuario = this.avance.misiones[
        this.mision - 1
      ].respuestas;

      console.log({ avance: this.avance });

      let inIdsPrueba = await this.$store.dispatch("inIdsPrueba");

      if(this.avance.misiones[0].resultado_evaluacion != null && inIdsPrueba === false){
        this.$router.push("/mision-1-resultados")
      }
    },
    async getLocalStorage() {
      this.avance = await this.$store.dispatch("getLocalStorage");
    },
    click(e) {
      // Todo
    },
    sort(e) {
      const { oldIndex, newIndex } = e;
      console.log(oldIndex, newIndex);
    },
    sortend(e, list, reto) {
      console.log(reto);
      console.log(list);
      this.lista_ordenada = list;

      this.respuestas_usuario[reto].respuestas = list;

      console.log({ sortend: this.respuestas_usuario });

      const { oldIndex, newIndex } = e;
      this.rearrange(list, oldIndex, newIndex);
    },
    rearrange(array, oldIndex, newIndex) {
      if (oldIndex > newIndex) {
        array.splice(newIndex, 0, array[oldIndex]);
        array.splice(oldIndex + 1, 1);
      } else {
        array.splice(newIndex + 1, 0, array[oldIndex]);
        array.splice(oldIndex, 1);
      }
    },
    avanzar() {
      // if (this.res === -1) {
      //   swal.fire(
      //     "Oops",
      //     "Selecciona una opción antes de continuar...",
      //     "warning"
      //   );
      //   return;
      // }

      this.setAvance();

      //this.resultado = true;
    },
    retroceder() {
      this.$router.push("/mision-1-template/" + this.reto);
    },
    async setAvance() {
      let thes = this;
      let data = {
        index_mision: this.mision - 1,
        write: {
          mision: this.mision,
          reto: this.reto + 1,
          total: this.retos.length,
          respuestas: this.respuestas_usuario,
          resultado_evaluacion: this.resultado_evaluacion,
        },
      };

      await this.$store.dispatch("setAvance", data);

      if (this.reto + 2 <= this.retos.length) {
        this.$router.push("/mision-1-template/" + (this.reto + 2));
      } else {
        swal
          .fire({
            title: "¿Estás seguro(a) de enviar tus respuestas?",
            icon: "info",
            html:
              "Recuerda que no hay vuelta atrás, no podrás cambiar tus respuestas para este nivel más adelante. Selecciona 'No estoy seguro' para cambiar tus respuestas.",
            showCancelButton: true,
            confirmButtonText: `Sí, continuar`,
            cancelButtonText: `No estoy seguro`,
          })
          .then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              thes.confirmarRespuestas();
            }
          });
      }
    },
    async confirmarRespuestas() {
      this.evaluar();

      let data = {
        index_mision: this.mision - 1,
        write: {
          mision: this.mision,
          reto: this.reto + 1,
          total: this.retos.length,
          respuestas: this.respuestas_usuario,
          resultado_evaluacion: this.resultado_evaluacion,
          habilidades: this.suma,
        },
      };

      await this.$store.dispatch("setAvance", data);
      await this.$store.dispatch("registroMision1", data);
      //this.resultado = true;

      this.$router.push("/mision-1-resultados");
    },
    evaluar() {
      this.respuestas_usuario.forEach((element) => {
        console.log(element.respuestas);
        for (var i = 0; i < element.respuestas.length; i++) {
          let valor = 4 - i;
          this.suma["habilidad_" + element.respuestas[i].habilidad] += valor;
        }
      });

      console.log({ sumas: this.suma });

      //obtener x
      //categoria 2 - categoria 0
      this.x = this.suma["habilidad_2"] - this.suma["habilidad_0"];

      //obtener y
      //cat 3 - cat 1
      this.y = this.suma["habilidad_3"] - this.suma["habilidad_1"];

      console.log({ x: this.x, y: this.y });

      //asimilador
      // if (this.x >= 3 && this.x <= 18 && this.y >= -18 && this.y <= 2) {
      //   this.resultado_evaluacion = "Asimilador";
      // } else if (this.x >= 3 && this.x <= 18 && this.y >= 3 && this.y <= 18) {
      //   this.resultado_evaluacion = "Convergente";
      // } else if(this.x >= -18 && this.x <= 2 && this.y >= -18 && this.y <= 2) {
      //   this.resultado_evaluacion = "Divergente";
      // } else if (this.x >= -18 && this.x <= 2 && this.y >= 3 && this.y <= 18) {
      //   this.resultado_evaluacion = "Acomodador";
      // }

      if (this.x >= 3 && this.y <= 2) {
        this.resultado_evaluacion = "asimilador";
      } else if (this.x >= 3 && this.y >= 3) {
        this.resultado_evaluacion = "convergente";
      } else if (this.x <= 2 && this.y <= 2) {
        this.resultado_evaluacion = "divergente";
      } else if (this.x <= 2 && this.y >= 3) {
        this.resultado_evaluacion = "acomodador";
      }

      console.log({ resultado_evaluacion: this.resultado_evaluacion });
    },
    initTimer() {
      var vm = this;
      setTimeout(function () {
        vm.tick();
      }, 1000);
    },
    tick() {
      if (this.resultado === true) return;

      this.time++;
      var vm = this;
      setTimeout(function () {
        vm.tick();
      }, 1000);
    },
    siguienteMision() {
      this.$router.push("/mision-1-2");
    },
    toggleOraculo() {
      this.oraculo = !this.oraculo;
    },
  },
};
</script>


<style lang="scss" scoped>
.mision {
  .contentabs {
    .oraculo {
      top: 0%;
      width: 34vw;
      right: 0vw;
      position: absolute;
      z-index: 100;
      cursor: pointer;
      .btnoraculo {
        width: 80%;
        margin-left: 20%;
        position: relative;
      }
      .dialogo {
        position: absolute;
        right: 0%;
        top: 0%;
        width: 120%;
        visibility: hidden;
        pointer-events: none;
        &.active {
          visibility: visible;
          pointer-events: initial;
        }
        .cerrar {
          position: absolute;
          top: 3%;
          right: 6%;
        }
        .titulo {
          position: absolute;
          width: 50%;
          margin: 0 10% 0 40%;
          top: 12%;
          height: 20%;
          display: flex;
          align-items: center;
          font-size: 1.5vw;
        }
        .texto {
          position: absolute;
          width: 80%;
          margin: 0 10%;
          top: 40%;
          font-size: 1.4vw;
        }
      }
    }
    .tiempo-score {
      position: absolute;
      bottom: 3vw;
      right: 8vw;
      width: 20vw;
    }
    .btnavanzar {
      color: white;
      top: 14.5%;
      right: 0%;
      width: 25%;
      position: absolute;
      min-height: 5vw;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      transition: 0.25s all ease-out;
      cursor: pointer;
      img {
        width: 20vw;
        padding: 0.4vw 0.6vw;
        float: left;
        position: absolute;
        right: 0%;
        top: 50%;
        transform: translateY(-50%);
      }
      .texto {
        position: absolute;
        z-index: 100;
        top: 8%;
        left: 35%;
        min-height: 5vw;
        width: 62%;
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
        padding: 0.5vw;
        font-size: 0.9vw;
        span {
          font-size: 1.05vw;
          text-align: left;
        }
      }
      &:hover {
        transform: scale(1.1);
      }
    }
    .btnretroceder {
      color: white;
      top: 14.5%;
      left: -5%;
      width: 25%;
      position: absolute;
      min-height: 5vw;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      transition: 0.25s all ease-out;
      cursor: pointer;
      img {
        width: 20vw;
        padding: 0.4vw 0.6vw;
        float: left;
        position: absolute;
        right: 0%;
        top: 50%;
        transform: translateY(-50%);
      }
      .texto {
        position: absolute;
        z-index: 100;
        top: 8%;
        left: 45%;
        min-height: 5vw;
        width: 62%;
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
        padding: 0.5vw;
        font-size: 0.9vw;
        span {
          font-size: 1.05vw;
          text-align: left;
        }
      }
      &:hover {
        transform: scale(1.1);
      }
    }
    .menu {
      bottom: 0%;
      left: 0%;
      right: 0%;
      width: 100%;
      position: absolute;
      .medidor {
        width: 88%;
        margin: 0 6%;
      }
      .contenedoropciones {
        position: absolute;
        top: -120%;
        width: 100%;
        .opcionessortable {
          position: relative;
          top: -200%;
          width: 24%;
          margin: 0 0.4%;
          float: left;
          .opcion {
            position: relative;
            .texto {
              position: absolute;
              top: 46%;
              transform: translateY(-50%);
              color: white;
              position: absolute;
              font-size: 0.9vw;
              width: 60%;
              margin: 0 20%;
              font-weight: bold;
              text-align: center;
            }
            img {
              width: 100%;
            }
          }
        }
        .opcionessortable > *.dragging {
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
        }
      }
    }
    .pregunta {
      top: 0%;
      left: 8%;
      width: 72%;
      position: absolute;
      .pregunta_txt {
        top: 50%;
        transform: translateY(-50%);
        left: 0%;
        width: 70%;
        margin: 0 0 0 20%;
        position: absolute;
        div {
          font-size: 1.2vw;
        }
      }
    }
    .quasar {
      top: 4.3%;
      left: 13%;
      width: 7%;
      position: absolute;
      animation: float 6s ease-in-out infinite;
      z-index: 100;
    }

    .mensaje {
      position: absolute;
      top: -12vw;
      left: 50%;
      width: 22vw;
      z-index: -1;
      img {
        width: 100%;
      }
      .texto {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        padding: 0.3vw 1vw 0.3vw 2vw;
        display: flex;
        justify-content: center;
        align-items: center;
        div,
        span {
          font-size: 1.4vw;
        }
      }
      &.invertido {
        left: -15vw;
        .texto {
          padding: 0.3vw 1vw 0.3vw 2vw;
        }
      }
    }
    .checkbox {
      top: -20%;
      width: 6%;
      position: absolute;
      cursor: pointer;
      .check {
        position: absolute;
        top: 0%;
        left: 10%;
        width: 100%;
        visibility: hidden;
        pointer-events: none;
        &.active {
          visibility: visible;
        }
      }
    }
    .checkbox1 {
      left: 13.5%;
    }
    .checkbox2 {
      left: 35.5%;
    }
    .checkbox3 {
      left: 58%;
    }
    .checkbox4 {
      left: 81%;
    }
  }
}

.bg1 {
  background-image: url(../../../assets/imgs/mision/1/bg-mision-1-1.jpg);
}
.bg2 {
  background-image: url(../../../assets/imgs/mision/1/bg-mision-1-2.jpg);
}
.bg3 {
  background-image: url(../../../assets/imgs/mision/1/bg-mision-1-3.jpg);
}
.bg4 {
  background-image: url(../../../assets/imgs/mision/1/bg-mision-1-4.jpg);
}
.bg5 {
  background-image: url(../../../assets/imgs/mision/1/bg-mision-1-5.jpg);
}
.bg6 {
  background-image: url(../../../assets/imgs/mision/1/bg-mision-1-6.jpg);
}
.bg7 {
  background-image: url(../../../assets/imgs/mision/1/bg-mision-1-7.jpg);
}
.bg8 {
  background-image: url(../../../assets/imgs/mision/1/bg-mision-1-8.jpg);
}
.bg9 {
  background-image: url(../../../assets/imgs/mision/1/bg-mision-1-9.jpg);
}

.mision1_1 {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
  .alien {
    bottom: 0%;
    left: 12%;
    width: 13%;
    position: absolute;
    .atomo {
      position: absolute;
      top: 0%;
      left: -40%;
      width: 150%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .smartphone {
    top: -90%;
    left: 34%;
    width: 8%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -25%;
      left: -65%;
      width: 240%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .libro {
    top: -80%;
    left: 55%;
    width: 12%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -65%;
      left: -40%;
      width: 180%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .guantes {
    top: -105%;
    left: 78%;
    width: 12%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -25%;
      left: -45%;
      width: 180%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
}
</style>
